import { Component, Inject, Input, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UtilityService } from 'app/core/services/utility_functions/utility_functions.service';
import _ from 'lodash';

@Component({
  selector: 'app-serial-numbers-dialog',
  templateUrl: './serial-numbers-dialog.component.html',
  styleUrls: ['./serial-numbers-dialog.component.scss']
})
export class SerialNumbersDialogComponent implements OnInit {
  dialogData: any;
  locationData: any;
  serialNumbersDisplayedColumns = ['id', 'serial_number'];
  pagination = {
    pageIndex: 1,
    pageSize: 10,
  };
  goTo: number = 1;
  dataSource: any = [];
  productDetails: any = {};
  searchKey: string = '';
  mockDataSource: any = [];
  constructor(
    dialogRef: MatDialogRef<SerialNumbersDialogComponent>,
    @Inject (MAT_DIALOG_DATA) public data: any,
    public utilityService: UtilityService
  ) { }

  ngOnInit(): void {
    this.dialogData = this.data.data;
    this.locationData = this.dialogData.locationData;
    this.productDetails = this.dialogData?.productDetails;
    this.setDataSource();
  }

  setDataSource(): void{
    const currentData = this.mockDataSource?.length > 0 ? this.mockDataSource : this.locationData?.serial_nos;
    const mockDataSource = _.cloneDeep(currentData);
    const startIndex = this.pagination?.pageIndex === 1 ? 0 : (((this.pagination?.pageIndex -1) * this.pagination?.pageSize)+1);
    this.dataSource = mockDataSource.splice(startIndex,this.pagination?.pageSize);
  }

  onPageEvent(event): void {
    if(this.pagination?.pageSize !== event.pageSize){
      this.goTo = 1;
    }
    this.pagination = {
      ...this.pagination,
      pageSize: event.pageSize,
      pageIndex: event.pageIndex+1,
    };
    const currentPageData = (this.locationData?.serial_nos?.length - (this.pagination?.pageIndex * this.pagination?.pageSize));
    if(currentPageData > 0){
      this.setDataSource();
    }
  }
  get getMaxNumber(): number{
    return Math.ceil(Math.abs(this.dialogData.locationData?.serial_nos?.length / this.pagination.pageSize));
  }

  gotToPage(page: number): void{
    if(page !== this.pagination.pageIndex){
      this.pagination = {
        ...this.pagination,
        pageIndex: Number(page) - 1
      };
      this.onPageEvent(this.pagination);
    }
  }

  triggerSearch(searchStr: string): void{
    const mockData = _.cloneDeep(this.locationData?.serial_nos);
    this.pagination = {
      ...this.pagination,
      pageIndex: 1,
    };
    this.goTo = 1;
    const searchData = mockData.filter((data: any)=> data?.toString()?.includes(searchStr));
    console.log(searchData);
    
    this.mockDataSource = _.cloneDeep(searchData);
    this.setDataSource();
  }

}
